import { ContentBlocks } from "src/ui/ContentBlocks";
import { SeoHead } from "src/ui/SeoHead";

export default function HomePage({ prefix, title, canonical, data }) {
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <div className="position-relative">
        <ContentBlocks data={data} prefix={prefix} />
      </div>
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      prefix: "blog",
      title: "Blog",
      canonical: "/blog/",
      data: [
        { component: "Hero", props: { title: "Blog" } },
        {
          component: "BlogFeed",
          props: {
            className: "pb-5 pb-lg-6",
          },
        },
      ],
    },
  };
}
